// Single source of truth for which m5mLead fields a magnet's flow steps can
// actually save an answer to. A flow step's `step_columns[0]` value is only
// meaningful if BOTH sides agree on it:
//   - the client (magnet-flow.js) offers it as a "Saves to" choice
//   - the server (magnetPublic.js's KNOWN_FIELDS) reads it out of `fields`
//     when building the m5mLead insert
// Previously these were two independent, hand-maintained lists that had
// already drifted: the client suggested 'budget', 'timeline', 'message' —
// none of which are real m5mLead columns or read by the capture endpoint, so
// picking one silently dropped the answer into the lead's free-text
// description (or lost it outright, if a description step already existed).
export const LEAD_CAPTURE_FIELDS = [
  { value: 'name', label: 'Full name (splits into first + last automatically)' },
  { value: 'first_name', label: 'First name' },
  { value: 'last_name', label: 'Last name' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'mobile', label: 'Mobile phone' },
  { value: 'company', label: 'Company' },
  { value: 'title', label: 'Job title' },
  { value: 'city', label: 'City' },
  { value: 'state', label: 'State / province' },
  { value: 'product_interest', label: 'Product interest' },
  { value: 'lead_source', label: 'Lead source' },
  { value: 'rating', label: 'Rating (Hot / Warm / Cold)' },
  { value: 'description', label: 'Notes / description' },

  // Added 2026-08-10. These are all REAL m5mLead columns that the admin
  // console's Rollers builder had been offering for a long time while
  // capture() quietly ignored them — the answer went to the free-text
  // description transcript instead of its own column (or vanished entirely
  // when the flow had its own description step, since `fields.description ||
  // buildTranscript(fields)` lets an author-supplied description win). Rather
  // than removing the options and hiding that they never worked, capture()
  // now maps them properly. See magnetPublic.js's FIELD_MAX_LEN /
  // FIELD_NUMERIC — the two numeric columns need real coercion, they are not
  // free text.
  { value: 'salutation', label: 'Salutation (Mr. / Ms. / Dr.)' },
  { value: 'street', label: 'Street address' },
  { value: 'zip', label: 'Postal / ZIP code' },
  { value: 'country', label: 'Country' },
  { value: 'url', label: 'Website URL' },
  { value: 'industry', label: 'Industry' },
  { value: 'annual_revenue', label: 'Annual revenue (number)' },
  { value: 'employees', label: 'Number of employees (whole number)' },
  { value: 'is_primary', label: 'Primary contact (Yes / No)' },
  { value: 'current_generators', label: 'Current generator(s)' },
  { value: 'number_of_locations', label: 'Number of locations (whole number)' },
];

export const LEAD_CAPTURE_FIELD_VALUES = new Set(LEAD_CAPTURE_FIELDS.map((f) => f.value));
